<template>
  <div>
    <wc-data-box
      :title='$store.state.icons.dataBox.basics.title'
      :titleIcon='$store.state.icons.dataBox.basics.icon'
      :titleIconColor='$store.state.icons.dataBox.basics.iconColor'
      :showEdit='!estimate.is_sold'
      @edit='editBasics'
    >
      <wc-two-column-table :items='basicsData'></wc-two-column-table>
    </wc-data-box>

    <wc-dialog
      :showDialog='showEditDialog'
      :title='$store.state.icons.dataBox.basics.title'
      :icon='$store.state.icons.dataBox.basics.icon'
      @cancel='cancelEdit'
      @save='saveEstimate'
      :disableButtons='!isFormValid'
      width='450'
    >
      <v-form v-model='isFormValid' ref='form'>
        <v-text-field
          label='Estimate name'
          :rules='[rules.required]'
          v-model='estimateCopy.name'
          hint="Click avatar to use owner's name"
          :error='error'
          :error-messages='errorMessages'
          @focus='clearError'
          persistent-hint
          append-outer-icon='mdi-account'
          @click:append-outer='useOwnerName'
        ></v-text-field>
        <wc-datepicker
          required
          label='Estimate date'
          v-model='estimateCopy.estimate_date'
        ></wc-datepicker>
        <v-select
          label='Source'
          v-if="estimateCopy.estimate_type !== 'SE'"
          :items='$store.state.misc.globalOptions.estimateSource'
          v-model='estimateCopy.source'
        ></v-select>
        <v-checkbox
          v-if="estimateCopy.estimate_type !== 'SE'"
          label='Commercial ?'
          v-model='estimateCopy.is_comm'
        ></v-checkbox>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import formRules from '@/mixins/formRules'
import projectServices from '@/modules/projects/services/projects'


export default {
  name: 'estimate-basics',
  mixins: [formRules],
  props: {
    estimate: {
      required: true
    },
    project: {
      required: false,
    },
    wos: {
      required: false
    }
  },
  data: () => ({
    isLoading: false,
    isFormValid: false,
    showEditDialog: false,
    error: false,
    errorMessages: '',
    label: 'grey--text',
    dataValue: 'text-right',
    estimateCopy: {}
  }),
  computed: {
    projectRoute () {
      if (this.estimate.project !== null) {
        let routeName = projectServices.getProjectOverviewRoute(this.estimate.project_obj)
        return { name: routeName, params: { id: this.estimate.project_obj.id } }
      }
      return null
    },
    basicsData () {
      let data = []
      if (this.estimate) {
        data.push(
          { text: 'Estimate name', value: this.estimate.name },
          { text: 'Estimate number', value: this.estimate.number },
          { text: 'Estimate date', value: this.$options.filters.shortDate(this.estimate.estimate_date) },
          { text: 'Estimator', value: this.estimate.estimator ? this.estimate.estimator_obj.name_display : '' },
          { text: 'Date sold', value: this.$options.filters.shortDate(this.estimate.sold_date) },
        )
        if (this.estimate.project) {
          data.push({
            text: 'Project',
            value: this.estimate.project_obj.name,
            route: this.projectRoute
          })
        } else {
          data.push({
            text: 'Project',
            value: ''
          })
        }
        if (this.estimate.estimate_type !== 'SE') {
          data.push(
            { text: 'Source', value: this.estimate.source_display },
            { text: 'Site Type', value: this.estimate.is_comm ? 'Commercial' : 'Residential' }
          )
        }
        if (this.estimate.estimate_type !== 'NI' && this.wos && this.wos.length) {
          let i
          for (i = 0; i < this.wos.length; i++) {
            data.push({
              text: 'Work Order ' + (i + 1),
              value: this.wos[i].number,
              route: { name: 'WOOverview', params: { id: this.wos[i].id }}}
            )}
        } else {
          data.push({ text: 'Work Order', value: ''})
        }
      }
      return data
    }
  },
  methods: {
    editBasics () {
      this.estimateCopy = _.cloneDeep(this.estimate)
      this.showEditDialog = true
    },
    cancelEdit () {
      this.$refs.form.reset()
      this.showEditDialog = false
    },
    saveEstimate () {
      if (this.estimateCopy.division_obj.division_type === 'I') {
        if (this.estimateCopy.is_comm) {
          this.estimateCopy.estimate_detail.can_have_bm8 = false
          this.$emit('updateDetail', this.estimateCopy.estimate_detail)
        }
      }

      this.$emit('update', this.estimateCopy)
      this.showEditDialog = false
    },
    clearError () {
      this.error = false
      this.errorMessages = ''
    },
    useOwnerName () {
      if (!this.estimateCopy.owner) {
        this.error = true
        this.errorMessages = "Owner's name has not been set"
        setTimeout(() => {
          this.clearError()
        }, 6000)
      } else {
        if (this.estimateCopy.owner_obj.is_company) {
          this.estimateCopy.name = this.estimateCopy.owner_obj.name
        } else {
          this.estimateCopy.name = this.estimateCopy.owner_obj.last_name
        }
      }
    }
  }
}
</script>